import { useContext } from 'react'
import { GlobalContext } from '../../../context/Context';

const DataNotFound = ({ 
  title, 
  content, 
  className, 
  isIcon = false, 
  iconSVG, 
  iconURL, 
  width = 320,   // ✅ default width
  height = 240   // ✅ default height
}) => {
  let { state } = useContext(GlobalContext);

  return (
    <>
      {!isIcon ? (
        <p className={`noDataFound ${className}`}>
          {content ? (
            <>{content}</>
          ) : (
            <>
              No <span>{title}</span> Found
            </>
          )}
        </p>
      ) : (
        <div className="text-center flex flex-col items-center justify-center gap-2">
          {iconSVG ? (
            <div 
              className="icon-wrapper object-contain object-center max-h-[80%] max-w-[80%] m-auto"
              style={{
                width: `${width}px`,
                height: `${height}px`,
              }}
            >
              {iconSVG}
            </div>
          ) : (
            <img
              src={`${state.basePath}${iconURL}`}
              alt=""
              width={width}
              height={height}
              className="object-contain object-center max-h-[80%] max-w-[80%] m-auto"
            />
          )}

          <p className={`noDataFound ${className}`}>
            {content ? (
              content
            ) : (
              <>
                No <span>{title}</span> Found
              </>
            )}
          </p>
        </div>
      )}
    </>
  );
};

export default DataNotFound;